<template>
    <div>
        <div class="title7 flex-center">{{ $t('docx.title') }}</div>
        <div class="p-20">{{ $t('docx.tip_date') }}</div>
        <div class="p-20">
            <div class="title2">{{ $t('docx.tip1') }}</div>
            <div>{{ $t('docx.tip1_content1') }}</div>
        </div>
        <!-- 第二节 -->
        <div class="p-20">
            <div class="title2">{{ $t('docx.tip2') }}</div>
            <div>{{ $t('docx.tip2_content1') }}</div>
            <div>{{ $t('docx.tip2_content2') }}</div>
            <div>{{ $t('docx.tip2_content3') }}</div>
        </div>
        <!-- 第三节 -->
        <div class="p-20">
            <div class="title2">{{ $t('docx.tip3') }}</div>
            <div>{{ $t('docx.tip3_content1') }}</div>
            <div>{{ $t('docx.tip3_content2') }}</div>
            <div>{{ $t('docx.tip3_content3') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip3_content3_1') }}</div>
        </div>
        <!-- 第四节 -->
        <div class="p-20">
            <div class="title2">{{ $t('docx.tip4') }}</div>
            <div>{{ $t('docx.tip4_content1') }}</div>
            <div>{{ $t('docx.tip4_content2') }}</div>
            <div>{{ $t('docx.tip4_content3') }}</div>
            <!-- a b ... -->
            <div class=" m-l-20">{{ $t('docx.tip4_content3_a') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content3_b') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content3_c') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content3_d') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content3_e') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content3_f') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content3_g') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content3_h') }}</div>
            <div>{{ $t('docx.tip4_content4') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content4_a') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content4_b') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content4_c') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content4_d') }}</div>
            <div class=" m-l-20">{{ $t('docx.tip4_content4_e') }}</div>
        </div>

        <!-- 第五节 -->
        <div class="p-20">
            <div class="title2">{{ $t('docx.tip5') }}</div>
            <div>{{ $t('docx.tip5_content1') }}</div>
            <div>{{ $t('docx.tip5_content2') }}</div>
        </div>

        <div class="p-20">
            <div class="title2">{{ $t('docx.tip6') }}</div>
            <div>{{ $t('docx.tip6_content1') }}</div>
        </div>

        <div class="p-20">
            <div class="title2">{{ $t('docx.tip7_content1') }}</div>
            <div>{{ $t('docx.tip7_content2') }}</div>
        </div>
        <div class="p-20">
            <div class="title2">{{ $t('docx.tip8') }}</div>
            <div>{{ $t('docx.tip8_content1') }}</div>
            <div>{{ $t('docx.tip8_content2') }}</div>
        </div>

        <div class="p-20">
            <div class="title2">{{ $t('docx.tip9') }}</div>
            <div>{{ $t('docx.tip9_content1') }}</div>
        </div>

        <div class="p-20">
            <div class="title2">{{ $t('docx.tip10') }}</div>
            <div>{{ $t('docx.tip10_content1') }}</div>
            <div>{{ $t('docx.tip10_content2') }}</div>
        </div>

        <div class="p-20">
            <div class="title2">{{ $t('docx.tip11') }}</div>
            <div>{{ $t('docx.tip11_content1') }}</div>
        </div>

        
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    },

}
</script>